import React from "react";
import clsx from "clsx";
import Ink from "react-ink";

import Avatar from "../../../common/Avatar/Avatar";
import Link from "../../../nav/Link/Link";
import * as strings from "../../../../strings";
import Text from "../../../common/Text/Text";
import UserOrInviteAvatar from "../../../custom/UserOrInviteAvatar/UserOrInviteAvatar";

export interface SearchBarResultsProps<T> {
	onGetResultLink?: any;
	onSelect?: (item: T, e: React.SyntheticEvent) => void;
	results: T[] | undefined;
	maxResults: number;
	selection: number;
}

function SearchBarResults<T>(props: SearchBarResultsProps<T>) {
	const { results, onSelect, maxResults, onGetResultLink, selection } = props;

	return (
		<div className={"SearchBarResultsList"}>
			<Text tag={"p"} className={"SearchBarResultsList__header"}>
				{strings.DRIVERS_DRIVERS.toUpperCase()}
			</Text>
			<div className={"list"}>
				{results?.slice(0, maxResults).map((user: any, i: number) => {
					const name =
						user.firstName || user.lastName
							? `${user.firstName} ${user.lastName}`
							: undefined;

					const href = onGetResultLink && onGetResultLink(user);
					const element = href ? Link : "div";

					return React.createElement(
						element,
						{
							key: user.uid || user.email,
							className: clsx(
								"SearchBarResultsList__item",
								i === selection && "--active",
							),
							href: href,
							onClick: (e: any) => {
								if (onSelect) {
									onSelect(user, e);
								}
							},
						},
						<>
							<UserOrInviteAvatar userOrInvite={user} size={30} />
							<div className={"content"}>
								<span>{name}</span>
								<span>{user.email}</span>
							</div>
							<Ink />
						</>,
					);
				})}
			</div>
		</div>
	);
}

export default SearchBarResults;
